import React, { useState } from "react";
import "./Switch.css";

const Switch = ({ options, defaultValue, onChange, className = "" }) => {
  const [selectedOption, setSelectedOption] = useState(
    defaultValue || options[0]?.value,
  );

  const handleOptionClick = (option) => {
    setSelectedOption(option.value);
    if (onChange) onChange(option.value);
  };

  return (
    <div className={`switch-wrapper ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          className={`switch-option ${selectedOption === option.value ? "active" : ""}`}
          onClick={() => handleOptionClick(option)}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default Switch;
